/**
 * FishPrawnCrab game-domain types. Unlike Dragon Tiger (3 named bet
 * areas), FPC has 22 numeric bet item IDs, so `BetType` is just the
 * server-side betItemId.
 *
 * Mirrors packages/amgfishprawncrab_v2/lib/core/constants/game_constants.dart
 * + presentation/flame/main_flame_game.dart (bet ID list).
 */

export type GamePhase =
  | 'idle'
  | 'initializing'
  | 'modeSelection'
  | 'betting'
  | 'bettingClosed'
  | 'waitingResult'
  | 'diceReveal'
  | 'showResult'
  | 'result'
  | 'newRound'
  | 'error';

/** A BetType is the numeric betItemId. */
export type BetType = number;

/** Full list of valid bet IDs (from main_flame_game.dart:24-47). */
export const BET_ITEM_IDS: readonly number[] = [
  277, 272, 278,
  275, 273, 276, 274,
  279, 280, 281, 282, 283,
  284, 285, 286, 287, 288,
  289, 290, 331, 333, 334,
] as const;

const BET_ID_SET = new Set<number>(BET_ITEM_IDS);

export function isValidBetId(id: number): boolean {
  return BET_ID_SET.has(id);
}

export interface GameConfig {
  minBet: number;
  maxBet: number;
  chipValues: readonly number[];
}

export interface GameRound {
  roundId: string;
  nextRoundId: string;
  dice: readonly [number, number, number]; // 1..6 each
  /** History value derived from the result string trailing "@N" — used by the Rive history icons. */
  historyValue: number;
  totalWinLose: number;
  totalBet: number;
  positiveWinAmount: number;
  hasPositiveWin: boolean;
  /** Winning bet IDs (for chip distribution). Comes from BetResultItem.isWin in the server response. */
  winningBetIds: readonly number[];
}
